import { render, staticRenderFns } from "./u-mobile-nav-body-basic.vue?vue&type=template&id=4132551d&scoped=true"
import script from "./u-mobile-nav-body-basic.vue?vue&type=script&lang=js"
export * from "./u-mobile-nav-body-basic.vue?vue&type=script&lang=js"
import style0 from "./u-mobile-nav-body-basic.vue?vue&type=style&index=0&id=4132551d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4132551d",
  null
  
)

export default component.exports